module.exports = __webpack_public_path__ + "img/addPreButton.2b043240.svg";